import { Flex } from "styled-system/jsx";
import { useTranslation } from "react-i18next";
import { Text } from "@ttc3k/trekker";
import { ControlledAddressAutofill } from "shared/components/formControl/ControlledAddressAutofill";

export const BusinessLocationScreen = () => {
  const { t } = useTranslation();

  return (
    <Flex flexDir={"column"} gap={"150"}>
      <Text visual={"bodySemiBold"} color={"text.mid"}>
        {t("directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_LOCATION.TITLE")}
      </Text>
      <Text visual={"bodyRegular"} color={"text.mid"}>
        {t(
          "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_LOCATION.DESCRIPTION",
        )}
      </Text>
      <ControlledAddressAutofill
        addressInputName={"fullAddress"}
        addressObjInputName={"fullAddressObj"}
        coordsInputName={"fullAddressObj.location.coordinates"}
        lngInputName={"fullAddressObj.location.coordinates.lng"}
        latInputName={"fullAddressObj.location.coordinates.lat"}
      />
    </Flex>
  );
};
